module.exports = __webpack_public_path__ + "img/teacher.1c06efbe.png";